
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seite/[slug]",
      function () {
        return require("private-next-pages/seite/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/seite/[slug]"])
      });
    }
  